/**
 * Fallback trivia facts about U.S. higher education
 * Used when loading questions for colleges without specific trivia_facts
 */

export const FALLBACK_COLLEGE_TRIVIA = [
  "The first university in the United States was Harvard, founded in 1636.",
  "There are over 5,300 colleges and universities in the United States.",
  "The term 'alma mater' comes from Latin meaning 'nourishing mother.'",
  "College colors often have symbolic meaning - many were chosen in the 1800s based on heraldic traditions.",
  "The oldest college rivalry in the United States is between Yale and Harvard, dating back to 1875.",
  "Community colleges educate nearly half of all undergraduate students in the U.S.",
  "The U.S. has the world's largest higher education system by enrollment.",
  "Many college traditions like homecoming and class rings originated at American universities.",
  "Liberal arts colleges focus on undergraduate education in humanities, sciences, and social sciences.",
  "Research universities often have graduate programs and conduct cutting-edge research alongside teaching.",
  "College mascots became popular in the early 1900s as symbols of school spirit and athletic pride.",
  "The GI Bill of 1944 transformed higher education by making college accessible to millions of veterans.",
  "Study abroad programs help over 300,000 U.S. students experience education internationally each year.",
  "Many colleges started as single-sex institutions and later became coeducational.",
  "The first intercollegiate athletic event in the U.S. was a rowing race between Harvard and Yale in 1852.",
  "College fight songs often date back to the early 1900s and remain beloved traditions today.",
  "The semester system was adopted by most U.S. colleges in the mid-20th century.",
  "Work-study programs allow students to earn money while gaining professional experience on campus.",
  "College dining halls have evolved from basic cafeterias to include diverse, cuisine-focused options.",
  "Student newspapers have been a cornerstone of campus life since the 1800s.",
  "Greek life fraternities and sororities began in the late 18th century as literary societies.",
  "Many colleges have unique traditions like senior weeks, midnight breakfasts, or annual festivals.",
  "Campus architecture often reflects the era when a college was founded or expanded.",
  "College libraries serve as both study spaces and repositories of rare collections and archives.",
  "Honors programs offer advanced curricula and closer faculty mentorship for high-achieving students."
];

/**
 * Get a random trivia fact
 * @returns {string}
 */
export function getRandomTrivia() {
  const randomIndex = Math.floor(Math.random() * FALLBACK_COLLEGE_TRIVIA.length);
  return FALLBACK_COLLEGE_TRIVIA[randomIndex];
}

/**
 * Get trivia for a specific college, with fallback to general trivia
 * @param {Object} college - College object from database (may have trivia_facts field)
 * @returns {Array<string>} - Array of trivia facts
 */
export function getCollegeTriviaFacts(college) {
  // If college has trivia_facts in the future, use those
  if (college?.trivia_facts && Array.isArray(college.trivia_facts) && college.trivia_facts.length > 0) {
    return college.trivia_facts;
  }

  // Otherwise use fallback
  return FALLBACK_COLLEGE_TRIVIA;
}
